import { render, staticRenderFns } from "./HeroesProgramWidget.vue?vue&type=template&id=31fd7eb5&"
import script from "./HeroesProgramWidget.vue?vue&type=script&lang=js&"
export * from "./HeroesProgramWidget.vue?vue&type=script&lang=js&"
import style0 from "./HeroesProgramWidget.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports